import { Api, LocalDictionaryFactory } from  '../../../api/api.module'
import { LoggerService } from  '../../common.module'
import { CommonHelper, DataType, ViewColumnType } from '../../../../helpers/common-helper'
import { EventsNames } from '../../../../helpers/events-names'
import { i18n } from '../../i18n/common.i18n'
import { OperatorLayoutSettings } from '../../../../helpers/operator-layout-settings'
import { MeasurementsBridge } from '../measurements.controller'

enum KpiType {
    locations,
    meters
}

interface KpiMeasurementsScope extends ng.IScope {
    source: MeasurementsBridge
    kpiType: KpiType

    showMeasurements: boolean    
}

export class KpiMeasurementsController {
    constructor($scope: KpiMeasurementsScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory) {
        var promise: ng.IPromise<void> = null

        let idMeter = localDictionary.getViewColumnName(CommonHelper.IdMeter, DataType.HELPER_ID_LOCATION, ViewColumnType.BaseHelper); // WTF? HELPER_ID_METER?! xD I don't know i can change it ;p
        if (idMeter) {
            if ($scope.kpiType == KpiType.locations) {
                let idLocationLoc = localDictionary.getViewColumnName(CommonHelper.IdLocation, DataType.HELPER_ID_LOCATION, ViewColumnType.BaseHelper);
                if (idLocationLoc) {
                    promise = $q.all([api.kpi.getAggregationPeriods(),
                        localDictionary.getLocationsKPI(1, 1, idLocationLoc + "=" + $scope.source.id),
                        localDictionary.getMetersKPI(500, 1, idMeter + "=" + $scope.source.id)
                    ]).then(data => {
                        let aggregationPeriods: any[] = data[0].result;
                        let locations: any[] = data[1]['values'];
                        let meters: any[] = data[2]['values'];

                        if (locations.length > 0) {
                            $scope.source.aggregationPeriods = aggregationPeriods
                            $scope.source.groups = locations
                            $scope.source.meters = meters

                            $scope.showMeasurements = true
                        }
                    })
                }
            } else if ($scope.kpiType == KpiType.meters) {
                promise = $q.all([api.kpi.getAggregationPeriods(),
                    localDictionary.getMetersKPI(1, 1, idMeter + '=' + $scope.source.id)
                ]).then(data => {
                    let aggregationPeriods: any[] = data[0].result;
                    let meters: any[] = data[1]['values']

                    $scope.source.aggregationPeriods = aggregationPeriods
                    $scope.source.meters = meters

                    $scope.showMeasurements = true
                })
            }
        }

        if (promise) {
            promise.catch(reason => {
                CommonHelper.openInfoPopup(i18n("Common", "WebServiceException"), "error");
                logger.log(reason);
            })
        } else {
            CommonHelper.openInfoPopup(i18n("Common", "ExceptionOccuredPleaseContactAnAdministrator"), "error");
        }
    }
}